
// 转日期 formatTime(时间, 格式)
export const formatTime = (time, format) => {
  //let _time = new Date(typeof time === 'string' ? time.replace(/-/g, "/") : time)
  let _time = new Date(time)
  if (!format || format == '') {
    format = 'YYYY-MM-DD hh:mm:ss';
  }
  let date = {
    "M+": _time.getMonth() + 1,
    "D+": _time.getDate(),
    "h+": _time.getHours(),
    "m+": _time.getMinutes(),
    "s+": _time.getSeconds(),
    "q+": Math.floor((_time.getMonth() + 3) / 3),
    "S+": _time.getMilliseconds()
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (_time.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
    }
  }
  return format;
}
// 图片下载
export const downImg = function (imgUrl, imgName = 'images') {
  let src = imgUrl;
  let name = imgName;
  const image = new imgName;
  image.setAttribute('crossOrigin', 'anonymous');
  image.onload = function () {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, image.width, image.height);
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    const event = new MouseEvent('click');
    a.download = name;
    a.href = url;
    a.dispatchEvent(event); // 自定义事件触发器
  }
  image.src = src;
}
// 判断数据类型：
// undefined、null、string、number、boolean、array、
// object、symbol、date、regexp、function、
// asyncfunction、arguments、set、map、weakset、weakmap
export const DataType = (tgt, type) => {
  const dataType = Object.prototype.toString.call(tgt).replace(/\[object /g, "").replace(/\]/g, "").toLowerCase();
  return type ? dataType === type : dataType;
}



// WEBPACK FOOTER //
// ./src/utils/common.js